<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-search-box">
                    <div class="input-group">
                        <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search"
                               @keypress.enter="initList">
                        <div class="input-group-append">
                            <button class="all-btn search-btn" @click="initList">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_FUNCTION_TYPES_YIM_ADD')" @click="showOtherConfigAdd(null)">{{$t("action.add")}}</button>
              </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>ID</th>
                      <th>Яратилган сана</th>
                      <th>Яратган фойдаланувчи</th>
                  </tr>
                  </thead>
                  <tbody v-for="result in results.data" :key="result.id">
                  <tr @click="toggle(result.id)" :class="{ opened: opened.includes(result.id) }">
                      <td>{{result.id}}</td>
                      <td>{{new Date(result.createdDate) | dateFormat('DD.MM.YYYY HH:mm:ss')}}</td>
                      <td>{{result.createdBy.name}}</td>
                      <td class="td-actions text-center">
                          <button class="all-btn dark-btn table-action" v-tooltip="'Кўриш'">
                              <i class="fa fa-align-justify"></i>
                          </button>
                      </td>

                  </tr>
                  <template v-if="opened.includes(result.id)">

                      <tr>
                          <td colspan="2" style="width: 170px">№</td>
                          <td colspan="2" style="width: 170px">Вилоят</td>
                          <td colspan="2" style="width: 170px">Фаолия тури</td>
                          <td colspan="2" style="width: 170px">Коффицентлар</td>
                      </tr>

                      <tr v-for="resultVal in result.data.provincesBuildingTypes" :key="resultVal.id">
                          <td colspan="2" style="width: 170px">{{resultVal.id}}</td>
                          <td colspan="2" style="width: 170px">{{resultVal.provinceName}}</td>
                          <td colspan="2" style="width: 170px">{{resultVal.name}}</td>
                          <td colspan="2" style="width: 170px">{{resultVal.value}}</td>
                      </tr>
                  </template>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size"
                                  @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <function-types-yim-add-view></function-types-yim-add-view>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import FunctionTypesYimAddView from '@/views/config/real-estate/FunctionTypesYimAddView';

    export default {
        name: "FunctionTypesYim",
        components: {
            'b-pagination': bPagination,
            FunctionTypesYimAddView
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: {},
                opened: [],
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('dictionary/list/FUNCTION_TYPES_FOR_YIM', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showOtherConfigAdd(data) {
                this.$eventBus.$emit('showFunctionTypesYimAdd', data);
            },

            toggle(id) {
                const index = this.opened.indexOf(id);
                if (index > -1) {
                    this.opened.splice(index, 1)
                } else {
                    this.opened.push(id)
                }
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('functionTypesYimChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>
    .opened {
        background-color: #3d8b40;
    }
</style>